import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ spacing, typography, palette, breakpoints }) => {
    return {
      root: {
        height: '100%',
        transition: 'filter 0.2s',
        width: '100%',
        // cursor: 'pointer',
        filter: props =>
          props?.hoverShadow && 'drop-shadow(0px 10px 10px #CCC9CF)'
      },
      imageRead: {
        marginTop: 2,
        width: 54,
        height: 40,
        objectFit: 'cover',
        borderRadius: '6px',
        marginLeft: 1
      },
      imageVideo: {
        gridArea: 'container',
        objectFit: 'cover'
      },
      imageVideoBase: {
        width: '100%',
        height: '100%',
        borderRadius: spacing(1)
      },
      videoIcon: {
        backgroundColor: '#1D2D38',
        color: 'white',
        gridArea: 'container',
        borderRadius: '80%',
        padding: spacing(1),
        fontSize: '2.5em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      },
      videoContainer: {
        position: 'relative',
        height: '80px'
      },
      topic: ({ isConsumer }) => ({
        border: 'none',
        boxSizing: 'border-box',
        borderRadius: 8,
        marginRight: spacing(1),
        marginBottom: spacing(1),
        color: isConsumer ? palette.grey.shade[100] : palette.grey.shade[80],
        backgroundColor: isConsumer ? '#dadafe' : palette.common.white,
        fontWeight: typography.fontWeightRegular,
        ...typography.body.s,
        display: 'inline',
        width: '100%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        '& b': {
          fontWeight: typography.fontWeightBold
        },
        '&:hover': {
          background: isConsumer ? palette.primary.shade[5] : palette.grey.shade[5]
        },
        maxWidth: '100%'
      }),
      itemContainer: ({ isConsumer }) => ({
        marginBottom: spacing(1),
        cursor: 'pointer',
        '&:hover': {
          background: isConsumer ? palette.primary.shade[5] : '#f6f6f6'
        },
        '& > *:not(:first-child)': {
          paddingLeft: spacing(2)
        }
      }),
      itemDescRead: {
        flex: '1 1 0'
      },
      titleRead: ({ isConsumer }) => ({
        fontSize: '14px',
        lineHeight: '20px',
        ...(isConsumer && { color: 'black' }),
        ...(!isConsumer && { fontWeight: typography.fontWeightMedium })
      }),
      subtitleRead: ({ isConsumer }) => ({
        textTransform: 'capitalize',
        fontSize: '14px',
        ...(isConsumer && { fontWeight: typography.fontWeightBold, color: 'black' })
      }),
      cardTitle: {
        fontSize: '16px',
        lineHeight: '24px'
      },
      card: {
        width: '100%',
        height: '100%'
      },
      videoTitle: {
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px'
      },
      videoDivider: {
        height: '3px'
      },
      videoTime: {
        fontSize: '13px',
        color: palette.primary.main,
        fontWeight: 700
      },
      // MT.3 brand surfaces — these used to be gated behind isConsumer; the
      // refreshed brand now applies them universally so the right-rail
      // cards keep their characteristic backgrounds and title stripes
      // regardless of the user's group.
      consumerTopicsCard: {
        background: palette.primary.main
      },
      consumerRelatedCard: {
        background: '#dadafe'
      },
      // `&&` doubles specificity so these overrides win over
      // SectionHeader's internal `.root` class — that class is
      // inserted into the stylesheet AFTER ours (parent renders before
      // child), so equal-specificity CSS would otherwise let the base
      // dark-gray color leak through.
      relatedSectionHeader: {
        '&&': {
          color: palette.common.black
        }
      },
      topicsSectionHeader: {
        '&&': {
          color: palette.common.white
        }
      },
      videoSectionHeader: {
        '&&': {
          color: palette.white.off,
          fontSize: typography.heading.h5.fontSize,
          lineHeight: typography.heading.h5.lineHeight
        }
      },
      videoSectionHeaderFirst: {
        padding: spacing(0, 2),
        backgroundColor: '#C54925'
      },
      videoSectionHeaderSecond: {
        padding: spacing(0, 2),
        backgroundColor: '#A42F20'
      }
    }
  }
)
